import { useTranslation } from 'react-i18next'
import { imageUrl } from 'app/frontend/base/helpers'
import { EncounterAbilityCategory } from 'app/frontend/types/custom/EncounterEvents'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import SpellIcon from './SpellIcon'

const EJ_ICON_FILES: Partial<Record<EncounterAbilityCategory, string>> = {
  BLEED: 'bleed_icon.png',
  CURSE: 'curse_icon.png',
  DAMAGER: 'dps_icon.png',
  DISEASE: 'disease_icon.png',
  ENRAGE: 'enrage_icon.png',
  HEALER: 'healer_icon.png',
  INTERRUPT: 'interrupt_icon.png',
  MAGIC: 'magic_icon.png',
  POISON: 'poison_icon.png',
  TANK: 'tank_icon.png',
}

type EncounterAbilityLabelProps = {
  spellId: number
  name: string
  color: string
  categories?: EncounterAbilityCategory[]
}

const EncounterEjIcons = ({
  categories = [],
}: {
  categories?: EncounterAbilityCategory[]
}) => {
  const { t } = useTranslation()
  const icons = categories.filter((category) => EJ_ICON_FILES[category])

  if (icons.length === 0) return null

  return (
    <span className='inline-flex items-center gap-0.5 shrink-0'>
      {icons.map((category) => {
        const fileName = EJ_ICON_FILES[category]
        if (!fileName) return null
        const label = t(
          `dashboard.team.plans.ej-icons.${category.toLowerCase()}`,
        )
        return (
          <Tooltip key={category} disableHoverableContent>
            <TooltipTrigger asChild>
              <img
                src={imageUrl(`ej-icons/${fileName}`)}
                alt={label}
                className='w-4 h-4'
              />
            </TooltipTrigger>
            <TooltipContent className='text-sm pointer-events-none'>
              {label}
            </TooltipContent>
          </Tooltip>
        )
      })}
    </span>
  )
}

const EncounterAbilityLabel = ({
  spellId,
  name,
  color,
  categories = [],
}: EncounterAbilityLabelProps) => {
  return (
    <div className='w-full h-5 flex items-center gap-1'>
      <EncounterEjIcons categories={categories} />
      <a
        href={`https://wowhead.com/spell=${spellId}`}
        target='_blank'
        rel='noreferrer'
        className='min-w-0 grow text-xs text-muted-foreground truncate flex items-center gap-2'
        style={{ color }}
      >
        <span className='truncate grow text-right'>{name}</span>
        <SpellIcon
          spellId={spellId}
          className='w-5 h-5 rounded border border-border'
        />
      </a>
    </div>
  )
}

export default EncounterAbilityLabel
